export default "__VITE_ASSET__d646198f__"